import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table-tenant" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "dialog-footer" }

import { ref, onMounted, inject } from "vue";
import AccountService from "../../services/AccountService";
import VueJsonView from "@matpool/vue-json-view";

export default /*#__PURE__*/_defineComponent({
  __name: 'ReferralHistory',
  setup(__props) {

const isLoading = inject<any>("isLoading");
const show = ref(false);
const dialogData = ref(<any>[]);
const data = ref(<any>[]);
const criteria = ref({
  page: 1,
  size: 20,
});
const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await AccountService.getReferralHistory(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};
const showSchema = (data: any) => {
  show.value = true;
  dialogData.value = data;
};
const pageChange = (page: number) => {
  fetchData(page);
};
onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("fields.referralHistory")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.referralCode")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.referrerPartyId")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.InivtedPartyId")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1)
            ])
          ]),
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!_unref(isLoading) && data.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.code), 1),
                      _createElementVNode("td", null, _toDisplayString(item.referrerPartyId), 1),
                      _createElementVNode("td", null, _toDisplayString(item.referredPartyId), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: pageChange,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      width: "700",
      "align-center": "",
      style: {"max-height":"95vh","overflow":"auto"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (typeof dialogData.value != 'object')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(dialogData.value), 1))
          : (_openBlock(), _createBlock(_unref(VueJsonView), {
              key: 1,
              src: dialogData.value,
              theme: "rjv-default"
            }, null, 8, ["src"]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})